import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { RobotHostingType, RobotTypeAttended, RobotTypeUnattended, } from '@models';
import { ODATA_COUNT_KEY, ODataService, } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var RobotService = /** @class */ (function (_super) {
    tslib_1.__extends(RobotService, _super);
    function RobotService(http) {
        var _this = _super.call(this, http, MapperService.robotMap) || this;
        _this._endpoint = '/odata/Robots';
        _this.userNameSuggest = function (searchTerm, fetchSize, skip) {
            if (searchTerm === void 0) { searchTerm = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = {
                orderBy: ['Username'],
                top: fetchSize,
                skip: skip,
                filter: {
                    Username: {
                        contains: searchTerm,
                    },
                },
            };
            var endpoint = _this._endpoint + "/UiPath.Server.Configuration.OData.GetUsernames" + _this.getQueryString(queryOptions);
            return _this._http
                .get(endpoint)
                .pipe(map(function (res) { return ({
                data: res.value.map(function (robotName) { return ({
                    id: robotName,
                    text: robotName,
                }); }),
                total: res[ODATA_COUNT_KEY],
            }); }));
        };
        return _this;
    }
    RobotService.prototype.getRobotTypes = function (hostingType) {
        if (hostingType === void 0) { hostingType = RobotHostingType.Standard; }
        var filter = function (v) { return !isNaN(Number(v)); };
        var robotTypes = Object.keys(RobotTypeAttended).filter(filter);
        if (hostingType === RobotHostingType.Standard) {
            robotTypes = Object.keys(RobotTypeUnattended).filter(filter).concat(robotTypes);
        }
        return robotTypes.map(function (v) { return Number(v); });
    };
    RobotService.prototype.getMachineNameToLicenseKeyMappings = function () {
        var _this = this;
        return (this._http.get(this._endpoint + "/UiPath.Server.Configuration.OData.GetMachineNameToLicenseKeyMappings"))
            .pipe(map(function (response) { return _this._mapData(response); }));
    };
    RobotService.prototype.convertToFloating = function (robotId) {
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.ConvertToFloating", JSON.stringify({ robotId: robotId }));
    };
    RobotService.prototype.deleteBulk = function (keys) {
        var payload = JSON.stringify({ 'robotIds': keys });
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.DeleteBulk", payload);
    };
    return RobotService;
}(ODataService));
export { RobotService };
